/*
 * @Author: gaobin
 * @Date: 2025-07-04 10:59:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-04 11:13:46
 * @Description: 助力
 */
const helpMap = {
  // 生成助力砍订单
  createHelpChopOrder: '/usb/uwb-app/api/v1/helpChop/createHelpChop',
  // 生成助力砍分享链接
  getHelpChopShareLink: '/usb/uwb-app/api/v1/helpChop/getShareLink',
  // 分享者进度展示
  getHelpChopShareProgress: '/usb/uwb-app/api/v1/helpChop/help/show',
  // 被分享者进度展示
  getHelpChopJoinProgress: '/usb/uwb-app/api/v1/helpChop/doHelp/show',
  // 助力砍
  doHelpChop: '/usb/uwb-app/api/v1/helpChop/doHelp/add',
};

export default helpMap;
